/**
 * Lazy loaders for the console surfaces (ADR-WES1). Each starts what the
 * surface needs at once, so nothing waits on anything else:
 *
 * - ConsoleSurface: its chunk (stitch.css and console fonts) and the console
 *   message part for English and every locale requested so far. Outside the
 *   docs portal it also starts the console-only components App.tsx renders
 *   around the panels; their stand-ins wait for them if they are still on the
 *   way, under the same loading screen.
 * - AdminShell: its chunk, the admin fonts, and the English admin message part.
 */
import { requireMessageParts } from "../i18n";
import { loadAdminFonts } from "../lib/admin-fonts";
import { loadConsoleComponents } from "./lazy-console";

function ignore() {
  // The stand-in that needs the chunk retries and surfaces the failure.
}

export function loadConsoleSurface() {
  const docs = typeof window !== "undefined" && window.location.pathname.startsWith("/docs");
  if (!docs) void loadConsoleComponents().catch(ignore);
  return Promise.all([import("../components/ConsoleSurface"), requireMessageParts(["console"])]).then(
    ([surface]) => surface
  );
}

export function loadAdminShell() {
  loadAdminFonts();
  return Promise.all([import("../components/admin/AdminShell"), requireMessageParts(["admin"])]).then(
    ([module]) => ({ default: module.AdminShell })
  );
}
